import api from './api';

const STORAGE_KEY = 'pendingInviteToken';

export function getPendingInviteToken(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearPendingInviteToken(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/**
 * If a pending invite token exists in sessionStorage, accept it and return
 * a new session JWT scoped to the invited org. Clears the token regardless
 * of outcome so it is never retried.
 */
export async function acceptPendingInvite(currentToken: string): Promise<string | null> {
  const inviteToken = getPendingInviteToken();
  if (!inviteToken) return null;

  clearPendingInviteToken();

  try {
    const res = await api.post<{ token: string }>(
      '/auth/accept-invite',
      { token: inviteToken },
      { headers: { Authorization: `Bearer ${currentToken}` } },
    );
    return res.data.token ?? null;
  } catch {
    return null;
  }
}
